/**
 * 즐겨찾기 별 아이콘 — 입찰 공고 / 기업 공용.
 *
 * 사용 패턴:
 *   <FavoriteStar checked={isFav} onToggle={(next) => ...} />
 *
 * 동작:
 *   - 클릭 시 즉시 next 상태를 부모에게 전달 (낙관적 UI). API 호출은 부모가 책임.
 *   - 부모 카드의 onClick 이벤트와 충돌 안 하도록 stopPropagation 자동 처리.
 */
import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import StarBorderRoundedIcon from "@mui/icons-material/StarBorderRounded";

export default function FavoriteStar({ checked, onToggle, size = "small", tooltipOn = "즐겨찾기 해제", tooltipOff = "즐겨찾기 추가" }) {
    const handleClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
        onToggle?.(!checked);
    };
    return (
        <Tooltip title={checked ? tooltipOn : tooltipOff} placement="top">
            <IconButton
                size={size}
                onClick={handleClick}
                aria-label={checked ? "즐겨찾기 해제" : "즐겨찾기 추가"}
                sx={{
                    color: checked ? "#f59e0b" : "#cbd5e1",
                    "&:hover": { color: checked ? "#d97706" : "#f59e0b", bgcolor: "rgba(245, 158, 11, 0.08)" },
                    transition: "color 0.15s",
                }}
            >
                {checked ? <StarRoundedIcon fontSize="small" /> : <StarBorderRoundedIcon fontSize="small" />}
            </IconButton>
        </Tooltip>
    );
}
